import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export class AlertRule {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('TriggerType') triggerType: TriggerType;
  @JsonProperty('TriggerEntityId') triggerEntityId: string;
  @JsonProperty('TriggerEntityType') triggerEntityType: TriggerEntityType;
  @JsonProperty('Recipients') recipients: Array<string>;
  @JsonProperty('CreatedAt') createdAt: Date;
  @JsonProperty('LastFiredAt') lastFiredAt: Date;
  @JsonProperty('Language') language: string;
}

export enum TriggerType {
  ChargingStarted = 'charging-started',
  ChargingStopped = 'charging-stopped',
  OcppConnectionAborted = 'ocpp-connection-aborted',
  OcppConnectionRegained = 'ocpp-connection-regained',
  StationFaulted = 'station-faulted',
  StationUnavailable = 'station-unavailable',
  StationAvailable = 'station-available',
}

export enum TriggerEntityType {
  Station = 'station',
  StationGroup = 'station-group',
}
